import { InfoBlocks } from "../components/info-blocks/InfoBlocks";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" && staticType === "Info Blocks";

const create = (data: any): JSX.Element => {
  return <InfoBlocks />;
};

export default { test, create };
